import { ManufacturerApproved } from 'components/Toolkit/Tags/ManufacturerApproved';
import { CardPaymentTag } from 'components/Toolkit/Tags/PreBuilt/CardPaymentTag';
import { DeliveryAvailableTag } from 'components/Toolkit/Tags/PreBuilt/DeliveryAvailableTag';
import { HistoryCheckTag } from 'components/Toolkit/Tags/PreBuilt/HistoryCheckTag';
import { WarrantyTag } from 'components/Toolkit/Tags/PreBuilt/WarrantyTag';
import { Tag } from 'components/Toolkit/Tags/Tag';
import { GreenLightTag } from 'components/Toolkit/Tags/PreBuilt/GreenlightTag';
import { HerdwatchTag } from 'components/Toolkit/Tags/PreBuilt/HerdwatchTag';
import { WantedTag } from 'components/Toolkit/Tags/PreBuilt/WantedTag';
import styled from 'styled-components';

interface Merits {
  description?: string;
  colour?: string;
  text?: string;
  field?: string;
}

export interface ICardPayment {
  stripeAccountId?: string;
  quantity?: string;
  shippingFee?: string;
  shippingAvailable?: boolean;
  cardPaymentType?: string;
  acceptPayment?: boolean;
}

interface TagsProps {
  manufacturerApprovedBadge?: { badgeUrl?: string; manufacturer?: string };
  meritsV2?: Merits[];
  specialOffer?: string;
  greenlightVerified?: boolean;
  cardPayments?: ICardPayment[];
  deliveryAvailable: boolean;
  herdwatchVerified: boolean;
  wanted: boolean;
}

const TagListItem = styled.li<{ order: number }>`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
  margin-right: ${({ theme }) => theme.spacing.S8};
  order: ${({ order }) => order};
`;

const TagList = styled.ul`
  margin-bottom: ${({ theme }) => theme.spacing.S4};
  display: flex;
  flex-wrap: wrap-reverse;
  direction: rtl;
  justify-content: flex-end;
`;

function Tags(props: TagsProps) {
  const {
    wanted,
    deliveryAvailable,
    cardPayments,
    meritsV2,
    specialOffer,
    greenlightVerified,
    manufacturerApprovedBadge,
    herdwatchVerified,
  } = props;

  let tags = [];

  if (wanted) {
    tags.push(<WantedTag />);
  } else {
    if (deliveryAvailable) {
      tags.push(<DeliveryAvailableTag />);
    }

    if (cardPayments && cardPayments[0].acceptPayment) {
      tags.push(<CardPaymentTag />);
    }

    if (meritsV2) {
      const containsHistoryCheck = meritsV2.some(
        (merit) => merit.field === 'historyChecked',
      );
      if (containsHistoryCheck) {
        tags.push(<HistoryCheckTag />);
      }

      const containsWarranty = meritsV2.some(
        (merit) => merit.field === 'warranty',
      );
      if (containsWarranty) {
        tags.push(<WarrantyTag />);
      }
    }

    if (specialOffer) {
      tags.push(<Tag text={specialOffer} textColor="GREY_DARK" />);
    }

    if (greenlightVerified) {
      tags.push(<GreenLightTag />);
    }

    if (manufacturerApprovedBadge) {
      tags.push(
        <ManufacturerApproved
          manufacturer={manufacturerApprovedBadge.manufacturer ?? ''}
        />,
      );
    }

    if (herdwatchVerified) {
      tags.push(<HerdwatchTag />);
    }
  }

  return (
    <TagList>
      {tags.map((tag, index) => (
        <TagListItem key={index} order={index + 1}>
          {tag}
        </TagListItem>
      ))}
    </TagList>
  );
}

export { Tags };
